import React from 'react';
import { initialsOf, toneOf } from '../utils/chatFormat';
import styles from '../Chat.module.css';

/**
 * Person: a round avatar in one of five muted tones (or their photo).
 * Group: a rounded ink square with the conversation's initials.
 */
export default function ChatAvatar({ name, id, image, group = false, size = 'md', online = false, className = '' }) {
  const classes = [
    styles.avatar,
    group && styles.avatarGroup,
    size === 'sm' && styles.avatarSm,
    size === 'xs' && styles.avatarXs,
    !image && (group ? styles.toneInk : styles[`tone${toneOf(id || name)}`]),
    className,
  ].filter(Boolean).join(' ');

  const face = (
    <span className={classes} aria-hidden="true">
      {image ? <img src={image} alt="" /> : initialsOf(name)}
    </span>
  );
  if (!online) return face;
  return (
    <span style={{ position: 'relative', display: 'inline-flex', flex: '0 0 auto' }}>
      {face}
      <span className={styles.onlineDot} aria-label="Online" />
    </span>
  );
}
